<template>
  <div>
    <Breadcrumbs main="Admin" title="Platform Overview" />
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-body">
              <h4 class="mb-1">Welcome, {{ userName }}</h4>
              <p class="mb-0 text-muted">Manage Wakili platform companies and central resources.</p>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div v-for="stat in stats" :key="stat.title" class="col-xl-3 col-md-6">
          <div class="card">
            <div class="card-body progress-media">
              <div class="d-flex">
                <div class="flex-grow-1">
                  <h5>{{ stat.title }}</h5>
                  <span class="mb-0 d-block">{{ stat.subtitle }}</span>
                </div>
                <vue-feather :type="stat.icon" />
              </div>
              <h3 class="mt-3 mb-0">{{ stat.value }}</h3>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-xl-8">
          <div class="card">
            <div class="card-header">
              <h5>Platform Activity</h5>
            </div>
            <div class="card-body activity-scroll">
              <div class="activity">
                <div v-for="item in activity" :key="item.title" class="d-flex mb-3">
                  <div class="gradient-round m-r-30 gradient-line-1">
                    <vue-feather :type="item.icon" />
                  </div>
                  <div class="flex-grow-1">
                    <h6>{{ item.title }} <span class="pull-right f-14">{{ item.time }}</span></h6>
                    <p class="mb-0">{{ item.description }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xl-4">
          <div class="card">
            <div class="card-header">
              <h5>Quick Actions</h5>
            </div>
            <div class="card-body">
              <ul class="list-group list-group-flush">
                <li v-for="link in quickLinks" :key="link.title" class="list-group-item px-0">
                  <router-link :to="link.path" class="d-flex align-items-center">
                    <vue-feather :type="link.icon" class="me-2" />
                    {{ link.title }}
                  </router-link>
                </li>
              </ul>
            </div>
          </div>
          <div class="card">
            <div class="card-header">
              <h5>Your Account</h5>
            </div>
            <div class="card-body">
              <p class="mb-1"><strong>Email:</strong> {{ currentUser?.email || '—' }}</p>
              <p class="mb-1"><strong>Phone:</strong> {{ currentUser?.phoneNo || '—' }}</p>
              <p class="mb-0">
                <strong>Status:</strong>
                <span :class="currentUser?.active ? 'text-success' : 'text-danger'">
                  {{ currentUser?.active ? 'Active' : 'Inactive' }}
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { listCompanies } from '@/services/companyService'

export default {
  computed: {
    ...mapGetters('adminAuth', ['currentUser']),
    userName() {
      return this.currentUser?.fullName || 'Admin'
    },
  },
  data() {
    return {
      stats: [
        { title: 'Companies', subtitle: 'Registered firms', value: '—', icon: 'briefcase' },
        { title: 'Active Firms', subtitle: 'Currently active', value: '—', icon: 'check-circle' },
        { title: 'Inactive', subtitle: 'Deactivated firms', value: '—', icon: 'users' },
        { title: 'New This Month', subtitle: 'Companies added', value: '—', icon: 'trending-up' },
      ],
      activity: [],
      quickLinks: [
        { title: 'Manage Companies', path: '/admin/companies', icon: 'briefcase' },
        { title: 'Firm User Login', path: '/auth/login', icon: 'log-in' },
      ],
    }
  },

  created() {
    this.loadStats()
  },

  methods: {
    async loadStats() {
      try {
        const companies = await listCompanies()
        const now = new Date()
        const monthStart = new Date(now.getFullYear(), now.getMonth(), 1)
        const activeCount = companies.filter((c) => c.active).length
        const newThisMonth = companies.filter((c) => {
          if (!c.createdAt) return false
          return new Date(c.createdAt) >= monthStart
        }).length

        this.stats[0].value = String(companies.length)
        this.stats[1].value = String(activeCount)
        this.stats[2].value = String(companies.length - activeCount)
        this.stats[3].value = String(newThisMonth)

        this.activity = companies
          .slice()
          .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
          .slice(0, 5)
          .map((company) => ({
            title: company.companyName,
            time: company.createdAt
              ? new Date(company.createdAt).toLocaleDateString()
              : '—',
            description: `${company.companyCode ? company.companyCode + ' · ' : ''}${company.email} · ${company.active ? 'Active' : 'Inactive'}`,
            icon: 'briefcase',
          }))
      } catch {
        this.activity = [
          {
            title: 'Could not load companies',
            time: 'Now',
            description: 'Check that the API is running and you are signed in as a platform admin.',
            icon: 'alert-circle',
          },
        ]
      }
    },
  },
}
</script>
